import { useRef, useState } from 'react'
import { RulerIcon } from '@phosphor-icons/react'
import { ScoopTooltip, ScoopButton, ScoopText } from '../../../ui'
import styles from './SizePicker.module.scss'

export const SizePicker = ({ origin, value, onChange, tooltip }) => {
    const anchor = useRef()
    const [open, setOpen] = useState(false)

    const handleSelection = (size) => {
        switch (size) {
            case 'small':
                onChange({ width: 1280, height: 720 })
                break
            case 'medium':
                onChange({ width: 1600, height: 900 })
                break
            case 'large':
                onChange({ width: 1920, height: 1080 })
                break
        }
        setOpen(false)
    }

    const getPopoverPosition = () => {
        if (origin === 'top') {
            return styles.popoverTop
        } else {
            return styles.popoverBottom
        }
    }

    return (
        <>
            <ScoopTooltip title={'Change size'} disableHoverListener={!tooltip}>
                <ScoopButton variant="text" onClick={() => setOpen(true)} ref={anchor}>
                    <RulerIcon size={20} />
                </ScoopButton>
            </ScoopTooltip>
            {open && (
                <>
                    <div className={styles.backdrop} onClick={() => setOpen(false)} />
                    <div className={`${styles.popover} ${getPopoverPosition()}`} ref={anchor}>
                        <button
                            onClick={() => handleSelection('large')}
                            className={`${styles.menuItem} ${value.width === 1920 ? styles.selected : ''}`}
                        >
                            <ScoopText className={styles.menuItemText}>Large</ScoopText>
                        </button>
                        <button
                            onClick={() => handleSelection('medium')}
                            className={`${styles.menuItem} ${value.width === 1600 ? styles.selected : ''}`}
                        >
                            <ScoopText className={styles.menuItemText}>Medium</ScoopText>
                        </button>
                        <button
                            onClick={() => handleSelection('small')}
                            className={`${styles.menuItem} ${value.width === 1280 ? styles.selected : ''}`}
                        >
                            <ScoopText className={styles.menuItemText}>Small</ScoopText>
                        </button>
                    </div>
                </>
            )}
        </>
    )
}
